/**
 * Namespacing kluczy localStorage aktywnym profilem (finding P1-6).
 * Jeden account może mieć wiele profili w tej samej przeglądarce — każdy
 * cache (saldo, strój, tier fortuny, idempotency key, unlock ogrodu) musi być
 * izolowany, żeby profil B nie dziedziczył danych profilu A. Przełączenie
 * aktywnego `profileId` (login / profile-select / reset) atomowo przełącza
 * całą przestrzeń kluczy — brak wycieków między profilami.
 */
import { SaveLocal } from './SaveLocal.js';

const PROFILE_KEY = 'pieskowo.profileId';

/** Deterministyczny format: `<base>::<profileId|anon>`. */
export function scopeKeyWith(base: string, profileId: string | null | undefined): string {
  const ns = profileId && profileId.length > 0 ? profileId : 'anon';
  return `${base}::${ns}`;
}

/** Klucz scope'owany aktywnym profilem (z SaveLocal / localStorage). */
export function scopedKey(base: string): string {
  let pid: string | null = null;
  try {
    pid = SaveLocal.getProfileId();
  } catch {
    pid = null;
  }
  return scopeKeyWith(base, pid);
}

/** Wariant dla modułów, które trzymają własny wstrzykiwany `Storage`. */
export function scopedKeyIn(base: string, storage: Storage): string {
  let pid: string | null = null;
  try {
    pid = storage.getItem(PROFILE_KEY);
  } catch {
    pid = null;
  }
  return scopeKeyWith(base, pid);
}
